export enum Plan {
    FREE = "Free",
    BASIC = "Basic",
    PRO = "Pro",
    ULTRA = "Ultra",
    LEGACY = "Legacy"
}